/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
// This hook is mostly copied from
// https://usehooks-ts.com/react-hook/use-interval which has an MIT license.
import { useEffect, useRef } from 'react';

/**
 * This is the hook form of setInterval which can be used by react components.
 * On unmount of a component that uses this hook, the interval will be cleared.
 *
 * @param callback - a function that will be called after a delay in
 *                   milliseconds.
 * @param delay    - the number of milliseconds to wait before calling the
 *                   function. If this number is 0, the function will never be
 *                   called.
 */
export const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const tick = () => savedCallback.current && savedCallback.current();
    if (delay) {
      const intervalId = setInterval(tick, delay);
      return () => clearInterval(intervalId);
    }
  }, [callback, delay]);
};